/**
 * Org corrente per le letture dal browser. Le policy RLS di commerce_*, products, clients e lead_pipelines
 * hanno il ramo OR is_super_admin(): senza un filtro esplicito su organization_id un superadmin vedrebbe
 * le righe di tutte le org (negozi, conflitti, prodotti, pipeline di altre aziende). Ogni lettura quindi
 * aggiunge .eq('organization_id', org); senza org non si legge niente.
 */
import { getCurrentUserOrganizationId } from '../stores/referenceDataCache';

export const NO_ORG = 'organizzazione non trovata';

export async function currentOrgId(): Promise<string | null> {
  try {
    const id = await getCurrentUserOrganizationId();
    return typeof id === 'string' && id.length > 0 ? id : null;
  } catch {
    return null;
  }
}
